import axios from "axios";
import { BASEURL, requestWrapper, setConfig } from "./request.util";

export const getAgents = async () => await requestWrapper(axios.get(`${BASEURL}/agents`, setConfig()));

export const addAgent = async (agentDetails) => await requestWrapper(axios.post(`${BASEURL}/agent/create`, agentDetails, setConfig()));

export const editAgent = async (agentId, agentDetails) => await requestWrapper(axios.put(`${BASEURL}/agent/edit/${agentId}`, agentDetails, setConfig()));
